import { UsersAPI } from '../../lib/api/UsersAPI';

export const RECIEVE_USERS = 'USERS.RECIEVE_USERS';

const API = new UsersAPI();

export const fetchUsersForOrg = orgId => (dispatch) => {
  API.list(orgId)
    .then(({ data }) => data)
    .then(users => dispatch({
      type: RECIEVE_USERS,
      users,
    }));
};



// WEBPACK FOOTER //
// ./src/redux/actions/Users.js